import { useRef, useState, useCallback } from "react";
import { useSetState } from "ahooks";
import { message, Switch } from "antd";
import {
  SActionBtn,
  SDrawerOrModal,
  SFuncModalFormRef,
  SLowcodeList,
  STableActions
} from "shj-components";
import { config } from "./config.tsx";
import AddOrEdit from "./addOrEdit";
import { lendingInstitutionsList, lendingInstitutionsChangeState } from '@/services/fmsConfig'
const GeneralManage = () => {
  const listRef = useRef()
  const editRef = useRef<SFuncModalFormRef>({ onFinish: undefined });
  const [statusLoading, setStatusLoading] = useState<string[]>([]);
  const [state, setState] = useSetState(
    {
      loading: false,
      visible: false,
      record: {},
    })

  const fetchList = (values) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        let data = await lendingInstitutionsList(current, pageSize, rest.query);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  }

  const onAddOrEdit = (record = {}) => {
    setState({ visible: true, record: { ...record } })
  }

  const onSubmit = () => {
    editRef.current.onFinish?.()
  };

  const onCancel = () => {
    setState({ visible: false, record: {} })
  }

  const getStatusOptions = async () => {
    return Promise.resolve({})
  }
  const toggleAccountStatus = useCallback(async (ids: string[], state: boolean) => {
    setStatusLoading(prev => [...prev, ...ids]);
    try {
      const response = await lendingInstitutionsChangeState(state, ids);
      message.success(response?.message || '操作成功');
      listRef.current?.reload()
    } catch (error) {
      // message.error('操作失败');
    } finally {
      setStatusLoading(prev => prev.filter(id => !ids.includes(id)));
    }
  }, []);

  const handleStatusChange = useCallback((selectedRows: any[], state: boolean) => {
    const ids = selectedRows.map(row => row.id);
    toggleAccountStatus(ids, state);
  }, [toggleAccountStatus]);
  const extensions = {
    request: { fetchList, getStatusOptions },
    events: {
      onAdd: () => onAddOrEdit(),
      onEnables: ({ selectedRows }: any) =>
        selectedRows && handleStatusChange(selectedRows, false),
      onDisables: ({ selectedRows }: any) =>
        selectedRows && handleStatusChange(selectedRows, true)
    },
    status: {
      btnDisabled: ({ selectedRowKeys = [] }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      enabledName(text) {
        return text ? '启用' : '禁用'
      },
      actionRender(_: null, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
          <SActionBtn
            loading={statusLoading.includes(record.id)}
            onClick={() => handleStatusChange([record], !record.enabled)}
          >
            {record?.enabled ? '禁用' : '启用'}
          </SActionBtn>
        </STableActions>
      },
    }
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode={'group'} config={config} {...extensions} />
      <SDrawerOrModal width={700}
        onCancel={onCancel}
        onOk={onSubmit}
        open={state.visible}
        loading={state.loading}
        title={state.record.id ? '编辑' : '新增'}
      >
        {state.visible && <AddOrEdit editRef={editRef.current} onCancel={onCancel}
          fn={listRef.current?.reload}
          setLoading={(loading) => setState({ loading })}
          record={state.record} />}
      </SDrawerOrModal>
    </div>
  );
};

export default GeneralManage;